import { NotificationLineWebSocketMessage } from './type';
import { date } from 'quasar';
import formatDate = date.formatDate;
import { StatementStatus } from '@/app/graphql/statement/sdk.statement';
import { NotificationFragment, Origin } from '@/app/graphql/notification/sdk.notification';

export function mapNotifications(notifications: NotificationFragment[]): NotificationLineWebSocketMessage[] {
  return notifications.map((notification) => mapNotification(notification));
}
export function mapNotification(notification: NotificationFragment): NotificationLineWebSocketMessage {
  const message = {
    id: notification.id,
    status: notification.status,
    origin: notification.origin,
    recipient: notification.recipient,
    text: notification.message.text,
    title: notification.message.title,
    date: formatDate(notification.dateTime, 'DD.MM.YYYY'),
    time: formatDate(notification.dateTime, 'HH:mm:ss'),
    dateTime: notification.dateTime,
    icon: 'done',
    color: 'positive',
    classList: '',
    payload: notification.message.payload
      ? { ...JSON.parse(notification.message.payload), text: notification.message.text }
      : null,
  };
  if (notification.origin === Origin.Statement) {
    return {
      ...message,
      text: message.text ? `${message.origin}.${message.text}` : '',
      title: `${message.origin}.${message.title}`,
      idGroup: [message.id],
      icon:
        message.payload?.status === StatementStatus.Fail
          ? 'error_outline'
          : message.payload?.status === StatementStatus.NotFound
            ? 'info'
            : 'check_circle',
      color:
        message.payload?.status === StatementStatus.Fail
          ? 'negative'
          : message.payload?.status === StatementStatus.NotFound
            ? 'grey-6'
            : 'positive',
      classList:
        message.payload?.status === StatementStatus.Fail
          ? 'text-negative'
          : message.payload?.status === StatementStatus.NotFound
            ? 'grey-6'
            : 'text-positive',
    };
  }
  if (notification.origin === Origin.Payment) {
    const status = message.payload?.status ?? 'ERROR';
    return {
      ...message,
      color: 'negative',
      title: `PAYMENT.NOTIFICATIONS.MESSAGE.${status}.TITLE`,
      text: `PAYMENT.NOTIFICATIONS.MESSAGE.${status}.TEXT`,
    };
  }
  return message;
}
